function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_10808",
  "data-name": "\\uADF8\\uB8F9 10808",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_7504",
  "data-name": "\\uD328\\uC2A4 7504",
  d: "M2609.886,3575.332l-15.575-15.575a9.042,9.042,0,1,0-12.788,12.788l15.263,15.25a4.334,4.334,0,0,0,6.129-6.129l-12.963-12.962h0a.71.71,0,0,1,1-1h0l12.962,12.962a5.753,5.753,0,0,1-8.136,8.136l-15.263-15.25a10.462,10.462,0,1,1,14.795-14.795l15.575,15.575h0a.71.71,0,1,1-1,1Z",
  transform: "translate(-2577.461 -3555.689)",
  fill: "#94a0a9",
  stroke: "#707070",
  strokeWidth: 2
}));

function SvgClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.74,
    height: 36.792,
    viewBox: "0 0 35.74 36.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.cfd4c626.svg";
export { ForwardRef as ReactComponent };